import { render } from "./ServiceModal.vue?vue&type=template&id=42e98550&scoped=true"
import script from "./ServiceModal.vue?vue&type=script&lang=js"
export * from "./ServiceModal.vue?vue&type=script&lang=js"

import "./ServiceModal.vue?vue&type=style&index=0&id=42e98550&scoped=true&lang=scss"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42e98550"]])

export default __exports__